import { ButtonsAssets, IconAssets } from '../../utils/enums/assets';
import { BreackpointsX, BreackpointsY } from '../../utils/enums/breackpoints';
import { Colors } from '../../utils/enums/colors';
import { Image, Text } from '../../utils/types/gameObjects';

import { UIController } from './uiController';

export class UiButtons {
  static ExitBtn(context: Phaser.Scene, onClick?: () => void): [Image, Text] {
    const {
      topBtn: { x, y, scale, fontSize },
    } = UiButtons.prototype.twoBtnsCenterPos(context);

    const btn = context.add
      .image(x, y, ButtonsAssets.RED_DEFAULT_BTN)
      .setInteractive({ cursor: 'pointer' })
      .setScale(0.65 * scale);

    btn.addListener('pointerover', () => {
      btn.setTexture(ButtonsAssets.RED_HOVER_BTN);
    });
    btn.addListener('pointerout', () => {
      btn.setTexture(ButtonsAssets.RED_DEFAULT_BTN);
    });
    btn.addListener('pointerdown', () => {
      btn.setTexture(ButtonsAssets.RED_ACTIVE_BTN);
    });
    btn.addListener('pointerup', () => {
      btn.setTexture(ButtonsAssets.RED_HOVER_BTN);
      onClick?.();
    });

    const txt = context.add
      .text(x, y, 'Exit', {
        fontSize: `${fontSize}px`,
        color: Colors.BLACK,
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);

    return [btn, txt];
  }

  static PlayBtn(context: Phaser.Scene, onClick: () => void): [Image, Text] {
    const {
      bottomBtn: { x, y, scale, fontSize },
    } = UiButtons.prototype.twoBtnsCenterPos(context);

    const btn = context.add
      .image(x, y, ButtonsAssets.YELLOW_DEFAULT_BTN)
      .setInteractive({ cursor: 'pointer' })
      .setScale(0.65 * scale);

    btn.addListener('pointerover', () => {
      btn.setTexture(ButtonsAssets.YELLOW_HOVER_BTN);
    });
    btn.addListener('pointerout', () => {
      btn.setTexture(ButtonsAssets.YELLOW_DEFAULT_BTN);
    });
    btn.addListener('pointerdown', () => {
      btn.setTexture(ButtonsAssets.YELLOW_ACTIVE_BTN);
    });
    btn.addListener('pointerup', () => {
      btn.setTexture(ButtonsAssets.YELLOW_HOVER_BTN);
      onClick();
    });

    const txt = context.add
      .text(x, y, 'Play', {
        fontSize: `${fontSize}px`,
        color: Colors.BLACK,
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);

    return [btn, txt];
  }

  static ScoreBtn(context: Phaser.Scene, onClick: () => void): [Image, Text] {
    const {
      topBtn: { x, y, scale, fontSize },
    } = UiButtons.prototype.twoBtnsCenterPos(context);

    const btn = context.add
      .image(x, y, ButtonsAssets.GREEN_DEFAULT_BTN)
      .setInteractive({ cursor: 'pointer' })
      .setScale(0.65 * scale);

    btn.addListener('pointerover', () => {
      btn.setTexture(ButtonsAssets.GREEN_HOVER_BTN);
    });
    btn.addListener('pointerout', () => {
      btn.setTexture(ButtonsAssets.GREEN_DEFAULT_BTN);
    });
    btn.addListener('pointerdown', () => {
      btn.setTexture(ButtonsAssets.GREEN_ACTIVE_BTN);
    });
    btn.addListener('pointerup', () => {
      btn.setTexture(ButtonsAssets.GREEN_HOVER_BTN);
      onClick();
    });

    return [
      btn,
      context.add
        .text(x, y, 'Score', {
          fontSize: `${fontSize}px`,
          color: Colors.BLACK,
          fontFamily: "'Press Start 2P', 'cursive'",
        })
        .setOrigin(0.5),
    ];
  }

  static ScorePlayBtn(context: Phaser.Scene, onClick: () => void): [Image, Text] {
    const { x, y, scale, fontSize } = UiButtons.prototype.scoresPlayBtnPos(context);

    const btn = context.add
      .image(x, y, ButtonsAssets.YELLOW_DEFAULT_BTN)
      .setInteractive({ cursor: 'pointer' })
      .setScale(0.65 * scale);

    const txt = context.add
      .text(x, y, 'PLAY', {
        fontSize: `${fontSize}px`,
        color: Colors.BLACK,
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);

    btn.addListener('pointerover', () => {
      btn.setTexture(ButtonsAssets.YELLOW_HOVER_BTN);
    });
    btn.addListener('pointerout', () => {
      btn.setTexture(ButtonsAssets.YELLOW_DEFAULT_BTN);
    });
    btn.addListener('pointerdown', () => {
      btn.setTexture(ButtonsAssets.YELLOW_ACTIVE_BTN);
    });
    btn.addListener('pointerup', () => {
      btn.setTexture(ButtonsAssets.YELLOW_HOVER_BTN);
      onClick();
    });

    return [btn, txt];
  }

  static EndGameRestart(context: Phaser.Scene, onClick: () => void): [Image, Text] {
    const { x, y, fontSize } = UiButtons.prototype.scoresPlayBtnPos(context);

    const btn = context.add
      .image(x, y, ButtonsAssets.YELLOW_DEFAULT_BTN)
      .setInteractive({ cursor: 'pointer' })
      .setScale(0.7, 0.55);

    btn.addListener('pointerover', () => {
      btn.setTexture(ButtonsAssets.YELLOW_HOVER_BTN);
    });
    btn.addListener('pointerout', () => {
      btn.setTexture(ButtonsAssets.YELLOW_DEFAULT_BTN);
    });
    btn.addListener('pointerdown', () => {
      btn.setTexture(ButtonsAssets.YELLOW_ACTIVE_BTN);
    });
    btn.addListener('pointerup', () => {
      btn.setTexture(ButtonsAssets.YELLOW_HOVER_BTN);
      onClick();
    });

    const txt = context.add
      .text(x, y, 'NEW GAME', {
        fontSize: `${fontSize}px`,
        color: Colors.BLACK,
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);

    return [btn, txt];
  }

  static GameOverRestart(context: Phaser.Scene, onClick: () => void): [Image, Text] {
    const { x, y, scale, fontSize, imgX, textX } = UiButtons.prototype.scoresPlayBtnPos(context);

    const btn = context.add
      .image(x, y, ButtonsAssets.GREEN_DEFAULT_BTN)
      .setInteractive({ cursor: 'pointer' })
      .setScale(0.65 * scale);

    btn.addListener('pointerover', () => {
      btn.setTexture(ButtonsAssets.GREEN_HOVER_BTN);
    });
    btn.addListener('pointerout', () => {
      btn.setTexture(ButtonsAssets.GREEN_DEFAULT_BTN);
    });
    btn.addListener('pointerdown', () => {
      btn.setTexture(ButtonsAssets.GREEN_ACTIVE_BTN);
    });
    btn.addListener('pointerup', () => {
      btn.setTexture(ButtonsAssets.GREEN_HOVER_BTN);
      onClick();
    });

    context.add.image(imgX, y, IconAssets.RESET_ICON).setScale(0.5);

    const txt = context.add
      .text(textX, y, 'LVL1', {
        fontSize: `${fontSize}px`,
        color: Colors.BLACK,
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);

    context.input.keyboard.on('keydown-ENTER', () => {
      onClick();
    });

    return [btn, txt];
  }

  twoBtnsCenterPos(context: Phaser.Scene) {
    const [w, h] = UIController.widthHeight(context);
    const [x, y] = UIController.centerXY(context);

    let topbtnY = y - 110;
    let bottomBtnY = y + 30;
    let scale = 1;
    let fontSize = 32;

    if (w <= BreackpointsX.LAPTOP || h <= BreackpointsY.LG) {
      scale = 0.65;
      fontSize = 28;
    }
    if (w <= BreackpointsX.LAPTOP) {
      topbtnY = y - 70;
    }
    if (h <= BreackpointsY.LG) {
      topbtnY = y - 50;
      bottomBtnY = y + 40;
    }

    return {
      topBtn: { x, y: topbtnY, scale, fontSize },
      bottomBtn: { x, y: bottomBtnY, scale, fontSize },
    };
  }

  scoresPlayBtnPos(context: Phaser.Scene) {
    const [w, h] = UIController.widthHeight(context);
    const [x, y] = UIController.centerXY(context);

    let scale = 1;
    let fontSize = 32;
    let btnY = y + 200;

    let imgX = x - 80;
    let textX = x + 25;

    if (w <= BreackpointsX.LAPTOP || h <= BreackpointsY.LG) {
      scale = 0.65;
      fontSize = 28;
      btnY = y + 165;
      imgX = x - 70;
      textX = x + 20;
    }

    return { x, y: btnY, scale, fontSize, imgX, textX };
  }

  static ContinueBtn(context: Phaser.Scene, onClick: () => void): [Image, Text] {
    const {
      bottomBtn: { x, y, scale, fontSize },
    } = UiButtons.prototype.twoBtnsCenterPos(context);

    const btn = context.add
      .image(x, y, ButtonsAssets.YELLOW_DEFAULT_BTN)
      .setInteractive({ cursor: 'pointer' })
      .setScale(0.8 * scale);

    btn.addListener('pointerover', () => {
      btn.setTexture(ButtonsAssets.YELLOW_HOVER_BTN);
    });
    btn.addListener('pointerout', () => {
      btn.setTexture(ButtonsAssets.YELLOW_DEFAULT_BTN);
    });
    btn.addListener('pointerdown', () => {
      btn.setTexture(ButtonsAssets.YELLOW_ACTIVE_BTN);
    });
    btn.addListener('pointerup', () => {
      btn.setTexture(ButtonsAssets.YELLOW_HOVER_BTN);
      onClick();
    });

    const txt = context.add
      .text(x, y, 'Continue', {
        fontSize: `${fontSize}px`,
        color: Colors.BLACK,
        fontFamily: "'Press Start 2P', 'cursive'",
      })
      .setOrigin(0.5);

    return [btn, txt];
  }
}
